import * as setup from './datatables_setup';
import typeahead from 'typeahead-standalone';

$(function(){
  var ucfMode = $('#error_correction_table').data('ucf-mode') === true;
  var actionColumnIndex = ucfMode ? 7 : 8;
  var columns = [
    null,
    { className: "text-start", type: "string" },
    null,
    null,
    { className: "text-start", type: "string" }
  ];

  if (!ucfMode) {
    columns.push(null); // Segment Type
  }

  columns.push(
    { className: "text-start", type: "string" },
    { className: "text-start", type: "string" },
    null
  );

  $('#error_correction_table').dataTable({
    processing: true,
    language: {
      lengthMenu: "Show _MENU_ entries",
      processing: setup.tableStartProcessing(),
      emptyTable: "No data available in table"
    },
    drawCallback: setup.tableStopProcessing(),
    serverSide: true,
    ajax: {
      url: $('#error_correction_table').data('source'),
      dataSrc: 'data'
    },
    pagingType: "simple_numbers",
    columnDefs: [ { "orderable": false,  "targets": [ actionColumnIndex ] } ],
    columns: columns,
    lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
    searchDelay: 2000
  });

  $.fn.overrideNodeMethod = function(methodName, action) {
    var originalVal = $.fn[methodName];
    var thisNode = this;
    $.fn[methodName] = function() {
      if (this[0]==thisNode[0]) {
        return action.apply(this, arguments);
      } else {
        return originalVal.apply(this, arguments);
      }
    };
  };

  const inputElement = document.getElementById("error_form_product_identifier");
  if (inputElement) {
    typeahead({
      input: inputElement,
      source: {
        remote: {
          url: (inputQuery) => `/ndc_suggestions?term=${inputQuery}`,
          debounce: 400,
        }
      },
      hint: false,
      preventSubmit: true,
      minLength: 4,
      limit: 10, // no show all option
      // Updates the text box to only show the NDC number after an option is selected
      display: (item) => {
        return item.label?.split(' - ')[0] || inputElement.value;
      },
    });
  }
});
